import { readHubSpotHutkFromCookie } from './utils';

/** HubSpot Forms API v3 — unauthenticated submit (browser). */
const HUBSPOT_FORMS_SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit';

export type HubSpotBrand = 'MoneyBlock' | 'TradingBlock';

export interface HubSpotCreateUserSubmitParams {
  portalId: string;
  formGuid: string;
  email: string;
  brand: HubSpotBrand;
}

/**
 * POSTs to HubSpot before RestHub create user. Awaits completion; ignores response body/status
 * (callers may log failures). Does not throw — signup must proceed if HubSpot is down or CORS blocks.
 */
export async function submitHubSpotCreateUserForm(params: HubSpotCreateUserSubmitParams): Promise<void> {
  const { portalId, formGuid, email, brand } = params;
  const hutk = readHubSpotHutkFromCookie();

  const url = `${HUBSPOT_FORMS_SUBMIT_URL}/${encodeURIComponent(portalId)}/${encodeURIComponent(formGuid)}`;

  const body: {
    fields: Array<{ objectTypeId: '0-1'; name: string; value: string }>;
    context?: { hutk: string };
  } = {
    fields: [
      { objectTypeId: '0-1', name: 'email', value: email },
      { objectTypeId: '0-1', name: 'brand', value: brand },
    ],
  };

  if (hutk) {
    body.context = { hutk };
  }

  try {
    console.log('[HubSpot] Submitting create-user form', {
      portalId,
      formGuidPrefix: formGuid.length > 8 ? `${formGuid.slice(0, 8)}…` : formGuid,
    });

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    await response.text();

    if (!response.ok) {
      console.warn('[HubSpot] Create-user form returned non-OK status', response.status);
    }
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    console.warn('[HubSpot] Create-user form request failed (continuing with user create):', message);
  }
}

export function getBrandForHubSpotFromSiteGroup(): HubSpotBrand {
  const siteGroup = process.env.REACT_APP_TB_SITE_GROUP;
  return siteGroup === 'mb' ? 'MoneyBlock' : 'TradingBlock';
}
